module.exports = __webpack_public_path__ + "static/media/OD.3c1298dd.png";